module.exports = __webpack_public_path__ + "static/img/control.8ba2b47a.jpeg";